import * as api from './devops.api';
import * as queries from './devops.queries';
import * as mutations from './devops.mutations';

export * from './devops.api';
export * from './devops.queries';
export * from './devops.mutations';

export default { ...api, ...queries, ...mutations };
